import {
  Avatar,
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  Link,
  List,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import React from 'react';
import { FaLinkedin } from 'react-icons/fa';

const TheContextInvestorRightBlog: React.FC = () => (
  <>
    <Flex
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height="100%"
      py={{ xs: '30px', sm: '40px', md: '60px', lg: '80px' }}
      h="100%"
      minH={{ xs: '400px', lg: '400px' }}
      maxH={{ xs: '400px', lg: '400px' }}
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/webp/theContext-bg.webp"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(78.35deg, rgba(13, 96, 81, 0.8) 18.38%, rgba(83, 92, 143, 0.8) 86.05%)"
        pos="absolute"
        height="100%"
        width="100%"
        opacity="0.7"
      />
      <Container
        display="flex"
        as="section"
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir={{ xs: 'column', md: 'row' }}
        columnGap="24px"
        rowGap="30px"
        alignItems={{ xs: 'flex-start', md: 'flex-start' }}
        px={{ xs: '14px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Flex flexDir="column" rowGap="16px">
          <Heading
            color="white"
            fontSize={{ xs: '36px', sm: '42px', lg: '64px' }}
            fontWeight="800"
            lineHeight={{ xs: '35px', lg: '83px' }}
          >
            #TheContext
          </Heading>
        </Flex>
        <Box
          w="1.5px"
          h={{ md: '200px', lg: '300px', xl: '230px' }}
          bgColor="white"
          display={{ xs: 'none', md: 'block' }}
        />
        <Box
          w={{ xs: '70%', sm: '60%' }}
          h="1.5px"
          bgColor="white"
          display={{ xs: 'block', md: 'none' }}
        />
        <Flex flexDir="column" rowGap="8px">
          <Heading
            as="h1"
            mb={{ xs: '10px', md: '20px' }}
            variant="reportCardTitle"
            fontSize={{ xs: '27px', sm: '29px', md: '32px', lg: '54px' }}
            color="white"
            lineHeight={{ xs: '36px', sm: '40px', md: '46px', lg: '70.2px' }}
          >
            Investor Rights in Alternative Investment Funds (AIFs) in India:
            What You
          </Heading>
          <Text
            fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
            fontWeight="600"
            color="white"
            lineHeight="28px"
          >
            Parul Jain
          </Text>
          <Text
            fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
            fontWeight="600"
            color="white"
            lineHeight="28px"
          >
            Radhika Parikh
          </Text>
          <Text
            fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
            fontWeight="600"
            color="white"
            lineHeight="28px"
          >
            Ipsita Agarwalla
          </Text>
        </Flex>
      </Container>
    </Flex>
    <Container maxW="container.xl" pb="80px" pt="40px">
      <Flex
        flexDir={{ xs: 'column-reverse', md: 'row' }}
        px={{ xs: '8px', md: '0px' }}
      >
        <Flex
          w={{ xs: '100%', md: '27%' }}
          mt={{ xs: '32px', md: '0px' }}
          flexDir="column"
          rowGap="16px"
          mr={{ xs: '0px', md: '40px' }}
          ml={{ xs: '0px', sm: '10px' }}
          mb={{ xs: '16px', md: '8px' }}
        >
          <Heading
            fontSize="22px"
            lineHeight="22px"
            textAlign={{ xs: 'center', sm: 'left' }}
          >
            Follow the Authors
          </Heading>
          <Box
            w="100%"
            h="1.5px"
            bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
            my="8px"
          />
          {[
            {
              name: 'Parul Jain',
              position:
                'Lead – International Tax and Investment Funds Practice, Nishith Desai Associates',
              image:
                'https://static.levocdn.com/WGLBUT82/ParulJain-jfwup7ig4MpY.jpeg',
              linkedIn: 'https://www.linkedin.com/in/parul-jain-354aa6a/',
            },
            {
              name: 'Radhika Parikh',
              position:
                'Lead – GIFT City Office and Investment Funds Practice, Nishith Desai Associates',
              image:
                'https://static.levocdn.com/WGLBUT82/RadhikaParikh-FUGYXjxZzWd8.jpeg',
              linkedIn: 'https://www.linkedin.com/in/radhika-parikh-14326244/',
            },
            {
              name: 'Ipsita Agarwalla',
              position:
                'Leader – International Tax and Investment Funds Practice, Nishith Desai Associates',
              image:
                'https://static.levocdn.com/WGLBUT82/IpsitaAgarwal-eg6qlkfYJUFq.jpeg',
              linkedIn: 'https://www.linkedin.com/in/ipsita-agarwalla/',
            },
          ].map((item, index) => (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              <Flex
                key={index}
                flexDir={{ xs: 'column', sm: 'row', md: 'column' }}
                columnGap="20px"
                rowGap="16px"
              >
                <Flex
                  flexDir="column"
                  alignItems={{ xs: 'center', sm: 'flex-start' }}
                  rowGap="8px"
                >
                  <Box boxSize="95px" borderRadius="50%" overflow="hidden">
                    <Avatar
                      name={item.name}
                      w="100%"
                      h="100%"
                      src={item.image}
                      objectFit="cover"
                    />
                  </Box>
                  <Flex flexDir="column" rowGap="4px">
                    <Flex
                      alignItems="center"
                      gap="12px"
                      justifyContent={{ xs: 'center', md: 'start' }}
                    >
                      <Heading
                        variant="blogQuestion"
                        textAlign={{ xs: 'center', sm: 'left' }}
                      >
                        {item.name}
                      </Heading>
                      <Link href={item?.linkedIn} target="_blank">
                        <IconButton
                          aria-label="linkedin"
                          icon={<FaLinkedin size="28px" color="#067acc" />}
                          variant="unstyled"
                          cursor="pointer"
                        />
                      </Link>
                    </Flex>
                    <Text
                      variant="blogAnswer"
                      textAlign={{ xs: 'center', sm: 'left' }}
                      fontStyle="italic"
                    >
                      {item.position}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            </>
          ))}
        </Flex>
        <Box w={{ xs: '100%', md: '73%' }}>
          <Text variant="blogAnswer" mb="20px">
            The Alternative Investment Fund (AIF) industry has seen significant
            growth in India in recent years. In response, the Securities and
            Exchange Board of India (SEBI) has introduced key amendments aimed
            to ensure fairness and equal treatment for all investors. These
            changes emphasize that AIFs are blind pool investment vehicles and
            require that:
          </Text>
          {/* Bold */}
          <Box w={{ xs: '100%', md: '100%' }}>
            <Text variant="blogAnswer" mb="20px">
              <strong>
                1. AIFs are blind pool investment vehicles and require that:
                Investors have rights to the underlying investments in
                proportion to their capital commitment{' '}
              </strong>{' '}
              ("Pro-Rata Rights")
            </Text>
            <Text variant="blogAnswer" mb="20px">
              <strong>2. All investor rights must rank equally</strong>
              ("Pari-Passu Rights")
              <br />
              <br />
              These amendments may prompt fund managers to re-evaluate their
              fund structures, documents, and the rights negotiated with
              investors. Below, we explore the implications of these changes
              from both the investor and manager perspectives.
            </Text>
          </Box>

          <Box w={{ xs: '100%' }}>
            <Text variant="blogAnswer" mb="20px" fontWeight="800">
              Pro-Rata Rights: What Does It Mean for Investors?
            </Text>
            <Text variant="blogAnswer" mb="20px">
              Pro-Rata Rights are directly tied to the economic rights of
              Limited Partners (LPs) in the underlying investments and
              distributions from these investments. SEBI now mandates that these
              rights be maintained based on the inter-se ratio of{' '}
              <strong>capital commitments</strong> made by investors. <br />{' '}
              <br /> However, an investor’s capital commitment isn’t just used
              for making portfolio investments. It also covers management fees,
              operating expenses, and other fund liabilities. Investors
              typically negotiate different terms for fees or caps on expenses,
              meaning that one investor might end up using a larger portion of
              their capital commitment for fees and expenses compared to others.
              This can lead to uneven allocations across investors. <br />{' '}
              <br />
              If Pro-Rata Rights are interpreted based solely on total capital
              commitments, this could create impractical situations. For
              example, an investor with a larger unfunded commitment might find
              themselves in a position where they cannot make further
              investments due to lower management fees. Conversely, an investor
              with a smaller unfunded commitment might struggle to meet
              drawdowns. <br /> <br />
              Therefore, SEBI’s mandate may need to be understood as requiring
              Pro-Rata Rights based on unfunded capital commitments.
              <br /> <br />
              As a result, fund structures may need to be reassessed to ensure
              that investors' economic rights are in line with Pro-Rata
              principles. Importantly, SEBI has not grandfathered existing
              arrangements. If an AIF does not provide Pro-Rata Rights, it will
              be prohibited from accepting fresh commitments or making new
              investments. This could reduce the fund's size and impact overall
              fund performance. Additionally, distributing carried interest in
              line with Pro-Rata principles may become more complex,
              particularly when sharing it with investors (other than the
              manager, sponsor, or their employees).
            </Text>
          </Box>
          <Box my="16px">
            <Text variant="blogAnswer" fontWeight="800">
              Pari-Passu Rights: Ensuring Equal Treatment
            </Text>
            <br />
            <Text variant="blogAnswer">
              SEBI has also emphasized that all investors' rights should be
              pari-passu—equal in all respects. However, the regulator allows
              for differential rights, provided they don’t negatively impact the
              interests of other investors. AIFs raise funds from sophisticated
              investors, who often negotiate their rights upfront. A positive
              list of differential rights has been released by SEBI which
              inter-alia includes the following rights:
            </Text>
            <br />
            <Box>
              <UnorderedList>
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    Waiver of fund expenses for specific investors
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    Differential management fees, carried interest, and hurdle
                    rates
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    Co-investment rights
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer" py="16px">
                    Accelerated reporting for select LPs
                  </Text>
                </ListItem>
                <br />
              </UnorderedList>

              <Text variant="blogAnswer">
                While these provisions might reflect typical investor requests,
                some might question whether such detailed regulation of AIFs was
                necessary in the first place. <br /> <br />
                Fund managers now have to necessarily disclose the eligibility
                criteria for availing differential rights in the placement
                memorandum. Fund managers have been provided one month’s time to
                disclose the differential rights to SEBI and terminate the
                rights which are not in conformity with the positive list.
                Terminating of a negotiated right will put managers in a
                difficult position with investors. Certain rights which are not
                included in the positive list currently includes transfer
                rights, the manner and form of distribution (e.g. cash-only
                distribution, no in-specie distribution), restrictions on
                reinvestments, exemption from equalization premiums and
                draw-stop rights to name a few. Conducting an
                investor-by-investor exercise to determine whether their rights
                are in conformity with SEBI’s mandate may be a daunting
                exercise. This may be even more challenging in cases where
                managers have launched multiple AIFs.
              </Text>
            </Box>
          </Box>
          <Box my="40px">
            <Text variant="blogAnswer" fontWeight="800">
              The Road Ahead
            </Text>
            <Text variant="blogAnswer">
              The regulatory landscape for AIFs in India is evolving quickly.
              Both fund managers and investors need to stay updated and prepare
              to adopt these changes. While the amendments aim to foster
              fairness and transparency, they may require significant
              adjustments to how funds are structured and how rights are
              allocated and offered to investors. <br /> <br />
              By understanding and adapting to these shifts, AIF managers and
              investors can better navigate the changing landscape and ensure
              that their interests remain protected.
            </Text>
          </Box>
        </Box>
        {/*  */}
      </Flex>

      <Box w="100%" h="1.5px" mt="16px" mb="8px" bgColor="gray.700" />
      <Text variant="blogAnswer" fontStyle="italic" p="12px 12px 0px">
        <Heading variant="blogQuestion" fontStyle="normal" as="span">
          #TheContext by IVCA{' '}
        </Heading>
        – features opinion makers from the alternate investing industry with
        strong focus on India as investment destination. Watch this space for
        viewpoints on investment themes, emerging trends, economic analysis and
        latest industry insights.
      </Text>
      <Heading
        variant="blogQuestion"
        lineHeight="30px"
        pt="16px"
        fontStyle="italic"
        p="12px 12px 0px"
      >
        Content in this section is curated by team IVCA. To share feedback,
        connect with &nbsp;
        <Link
          href="mailto:paromita.sinha@ivca.in"
          target="_blank"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          paromita.sinha@ivca.in
        </Link>
      </Heading>
    </Container>
  </>
);

export default TheContextInvestorRightBlog;
